// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__g3QGe","checkmark":"Toggle_checkmark__va4GK","purple":"Toggle_purple__3oAvc"};